import { toFolder } from './folder';
import { MediaType } from '../../../constants/MediaType';
export const mapFoldersToTree = (folders, parentId) => folders.reduce((treeCategories, category) => [...treeCategories, {
  ...toFolder(category, parentId),
  subFolders: mapFoldersToTree(category.children, category.guid)
}], []);
const enterpriseMediaTypesToMediaTypes = {
  IMAGE: MediaType.Picture,
  VIDEO: MediaType.Video,
  VECTOR: MediaType.Shape,
  DOCUMENT: MediaType.Document,
  AUDIO: MediaType.Music,
  ARCHIVE: MediaType.Archive,
  MIXED: MediaType.Document,
  MODEL3D: MediaType.ThreeD
};
export const mapEnterpriseCategories = _ref => {
  let {
    category,
    subCategories
  } = _ref;
  return {
    guid: category.id,
    title: category.displayName,
    mediaType: enterpriseMediaTypesToMediaTypes[category.mediaType],
    systemTags: [],
    children: (subCategories || []).map(mapEnterpriseCategories)
  };
};